<td-wb-notification notificationType="warning"
                    notificationSize="full-width">
  <td-wb-notification-header>
    <td-wb-inline-icon-wrapper>
      <span translate="tdWb.globalNotificationBanner.gaml.HEADER"></span>
    </td-wb-inline-icon-wrapper>
  </td-wb-notification-header>

  <div *tdWbIfFeature="'GAML_WFL'">
    @if (gamlDueDate) {
      <div class="gaml-global-notification-banner__context">
        <span [innerHTML]="'tdWb.globalNotificationBanner.gaml.TEXT_1' | translate: { date: gamlDueDate | tdWbDate: { format: 'DATE_ALT' } }"></span>
      </div>
    }
    <div class="gaml-global-notification-banner__context">
      @if (gamlDueDate) {
        <span translate="tdWb.globalNotificationBanner.gaml.TEXT_2"></span>
      } @else {
        <span [innerHTML]="'tdWb.globalNotificationBanner.gaml.TEXT_3' | translate"></span>
      }
      <a id="td-wb-gaml-global-notification-banner-link"
          tdWbHref="modal.gaml"
          [tdWbHrefParams]="{ entryPoint: 'GAML_ATTESTATION_BANNER' }"
          [tdWbHrefTaggingEvent]="bannerAnalyticsEventLinkName">
        <u><span translate="tdWb.globalNotificationBanner.gaml.LINK"></span></u>
      </a>
    </div>
  </div>

  <div *tdWbIfNoFeature="'GAML_WFL'">
    <div class="gaml-global-notification-banner__context">
      <span [innerHTML]="'tdWb.globalNotificationBanner.gaml.TEXT_1' | translate: { date: gamlDueDate | tdWbDate: { format: 'DATE_ALT' }}"></span>
    </div>
    <div class="gaml-global-notification-banner__context">
      <span translate="tdWb.globalNotificationBanner.gaml.TEXT_2"></span>
      <a id="td-wb-gaml-global-notification-banner-link"
          tdWbHref="modal.gaml"
          [tdWbHrefParams]="{ entryPoint: 'GAML_ATTESTATION_BANNER' }"
          [tdWbHrefTaggingEvent]="bannerAnalyticsEventLinkName">
        <u><span translate="tdWb.globalNotificationBanner.gaml.LINK"></span></u>
      </a>
    </div>
  </div>
</td-wb-notification>
